import { getServerUri } from "./uriUtility";

export async function optimizeImage(source, fileName) {
  const response = await fetch(getServerUri("imageOptimizer/compress"), {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      accessToken: localStorage.getItem("session.accessToken"),
      source,
      ...(fileName ? { fileName } : {}),
    }),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Optimization failed (${response.status})`);
  }
  return response.json();
}
